import { render, staticRenderFns } from "./PaymentTypeCard.vue?vue&type=template&id=39e0a6a5&scoped=true"
import script from "./PaymentTypeCard.vue?vue&type=script&lang=js"
export * from "./PaymentTypeCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypeCard.vue?vue&type=style&index=0&id=39e0a6a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e0a6a5",
  null
  
)

export default component.exports